module.exports = __webpack_public_path__ + "img/soh.c330e520.svg";